import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UbsViewContainersModule } from '@urbannex/view-containers';
import { CategoryRoutingModule } from './category-routing.module';
import { CategoriesComponent } from './categories.component';


@NgModule({
  declarations: [CategoriesComponent],
  imports: [
    CommonModule,
    UbsViewContainersModule,
    CategoryRoutingModule
  ],
  exports: [
    CategoryRoutingModule
  ]
})
export class CategoriesModule { }
